import React from 'react';
import { Helmet } from 'react-helmet';
import { useTranslation } from 'react-i18next';
import { withErrorBoundary } from 'react-error-boundary';
import { handleError } from 'services/ErrorService';
import GenericViewError from 'components/Error/GenericViewError';
import DashboardComponent from 'components/Dashboard';

const DashboardView = () => {
  const { t } = useTranslation();

  return (
    <>
      <Helmet title={`${t('My Progress')} - Red Hat Learning`} />
      <div className="container-grid-responsive">
        <DashboardComponent />
      </div>
    </>
  );
};

export default withErrorBoundary(DashboardView, GenericViewError, handleError);
